


const initialState = {
    cart:[],
    isLoading:false,
    isError:false
}


export const cartReducer = (state=initialState,{type,payload})=>{

    switch(type){


        default:
            return state
    }

}